import { useState } from "react";
import { Input } from "../ui/input";
import { Chip } from "../lux";

// SALES-029: how the Days / Hours field BEHAVES — select-on-focus so typing
// replaces, stays empty while you type (no refill mid-keystroke), returns to
// automatic when left empty on blur, the day chips and the Hours "Use
// calculated" link. It never decides WHEN to recount from the dates: the screen
// owns that (the wizard derives from the dates; the edit form recounts only on a
// date change, never on open). This component just reports edits — value plus
// whether the number is now the agent's choice — and offers the presets.
export function DayHoursField({
  testid, value, manual, autoValue,
  onChange,            // (nextValue, nextManual)
  chips = [],          // [{ key, label, value, manual, active }]
  useCalculatedLabel,  // Hours only: shows a "Use calculated: N hours" link
  step = "1", min = "0",
}) {
  const [focused, setFocused] = useState(false);
  const [draft, setDraft] = useState("");
  const shown = focused ? draft : (value ?? "");

  return (
    <div className="space-y-2">
      <Input
        type="number" step={step} min={min}
        value={shown}
        className="bg-input border-border"
        data-testid={testid}
        onFocus={(e) => { setDraft(value == null ? "" : String(value)); setFocused(true); e.target.select(); }}
        onChange={(e) => {
          const v = e.target.value;
          setDraft(v);
          // Typing is the agent's choice; an empty box stays "chosen" so the
          // screen's derive effect can't refill it out from under the cursor.
          onChange(v, true);
        }}
        onBlur={() => {
          setFocused(false);
          if (draft === "") onChange(autoValue, false);
        }}
      />
      {(chips.length > 0 || useCalculatedLabel) && (
        <div className="flex gap-2 flex-wrap" data-testid={`${testid}-chips`}>
          {chips.map((c) => (
            <Chip key={c.key} active={c.active} onClick={() => onChange(c.value, c.manual)} testid={`${testid}-chip-${c.key}`}>
              {c.label}
            </Chip>
          ))}
          {useCalculatedLabel && (
            <button type="button" className="text-xs text-primary hover:underline" data-testid={`${testid}-use-calculated`} onClick={() => onChange(autoValue, false)}>
              {useCalculatedLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
